import {
  RIGHTTREATMENT_FETCHING,
  RIGHTTREATMENT_FAILED,
  RIGHTTREATMENT_SUCCESS,
} from "../actions/types";

const initialState = {
  result: null,
  isFetching: false,
  isError: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case RIGHTTREATMENT_FETCHING:
      return { ...state, result: null, isFetching: true, isError: false };
    case RIGHTTREATMENT_FAILED:
      return { ...state, result: null, isFetching: false, isError: true };
    case RIGHTTREATMENT_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    default:
      return state;
  }
}
